// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__rNesg","insightsList":"newBusinessInsightsMenu_insightsList__2zcir","active":"newBusinessInsightsMenu_active__3RQP2"};